import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AffiliateSettings } from '@deltager/organizers/admin/shared/models/AffiliateSettings';
import { AffiliateStartupService } from './affiliate-startup.service';

@Injectable({
  providedIn: 'root',
})
export class AffiliateService {
  private currentSettings: AffiliateSettings;

  constructor(
    private http: HttpClient,
    private startupService: AffiliateStartupService,
  ) {}

  url = `${environment.apiBaseURL}/affiliates/`;

  get settings(): AffiliateSettings {
    if (!this.currentSettings) {
      this.currentSettings = this.getLocalStorage(this.startupService.initializedWithAffId);
    }

    return this.currentSettings;
  }

  get countryCode(): string {
    return this.settings.cultureCode.split('-')[1].toUpperCase();
  }

  private getSettings(affId: number): Observable<AffiliateSettings> {
    return this.http.get<AffiliateSettings>(this.url + affId + '/settings').pipe(
      tap(response => {
        this.currentSettings = response;
        this.setLocalStorage(affId, response);
      }),
    );
  }

  public getOrganisers(): Observable<any> {
    return this.http.get<any>(this.url + this.currentSettings.affId + '/organizers').pipe();
  }

  public isNorwegianCultureCode(): boolean {
    return this.currentSettings.cultureCode === 'nb-no';
  }

  public getAffiliateTimezone(): string {
    return this.isNorwegianCultureCode() ? 'GMT+2' : 'GMT+1';
  }

  public getCurrency(): string {
    return this.isNorwegianCultureCode() ? 'kr' : '£';
  }

  getSettingsAsync(affId: number): Promise<AffiliateSettings> {
    // Try to fetch cached version
    const cached = this.getLocalStorage(affId);
    if (cached) {
      this.currentSettings = cached;
      return Promise.resolve(cached);
    }

    return this.getSettings(affId).toPromise();
  }

  private setLocalStorage(affId: number, data: Object) {
    const cacheName = `affSettings_${affId}`;
    sessionStorage.setItem(cacheName, JSON.stringify(data));
  }
  private getLocalStorage(affId: number): AffiliateSettings {
    const cacheName = `affSettings_${affId}`;
    const settings = JSON.parse(sessionStorage.getItem(cacheName));
    return settings;
  }
}
